import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import type { FieldTree } from '@angular/forms/signals';
import { FormField } from '@angular/forms/signals';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { SpSwitchComponent } from '@ui/sp-switch';

import type { AnimationSettings } from '@sites/entity-core';

@Component({
    selector: 'sp-animation-settings-signal',
    templateUrl: './sp-animation-settings-signal.component.html',
    styleUrls: ['./sp-animation-settings-signal.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule, TooltipModule, SpSwitchComponent, FormField],
})
export class SpAnimationSettingsSignalComponent {
    public readonly field = input.required<FieldTree<AnimationSettings>>();
    public readonly isDisabled = input<boolean>(false);

    public readonly effectiveIsActive = computed(() => !this.isDisabled() && this.field().isActive().value());

    protected readonly animationType = computed(() => this.field().animationType().value());

    protected onToggleIsActive(next: boolean): void {
        this.field().isActive().value.set(next);
    }

    protected onTypeChange(event: Event): void {
        const type = (event.target as HTMLSelectElement).value;

        // the 'center' position exists only for the 'fade' type
        if (type !== 'fade' && this.field().animationPosition().value() === 'center') {
            this.field().animationPosition().value.set('left');
        }
    }
}
